import { render, staticRenderFns } from "./datasetobs4modal.vue?vue&type=template&id=53c6cc2d&scoped=true"
import script from "./datasetobs4modal.vue?vue&type=script&lang=js"
export * from "./datasetobs4modal.vue?vue&type=script&lang=js"
import style0 from "./datasetobs4modal.vue?vue&type=style&index=0&id=53c6cc2d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c6cc2d",
  null
  
)

export default component.exports